export class ParseResponseError extends Error {
  constructor(url: string) {
    super(`Error parsing JSON data retrieved from: ${url}`);
    this.name = 'ParseResponseError';
  }
}
